import { render, staticRenderFns } from "./LabelReports.vue?vue&type=template&id=4fdfc938&"
import script from "./LabelReports.vue?vue&type=script&lang=js&"
export * from "./LabelReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdfc938')) {
      api.createRecord('4fdfc938', component.options)
    } else {
      api.reload('4fdfc938', component.options)
    }
    module.hot.accept("./LabelReports.vue?vue&type=template&id=4fdfc938&", function () {
      api.rerender('4fdfc938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/LabelReports.vue"
export default component.exports